import { render, staticRenderFns } from "./Addinformation.vue?vue&type=template&id=61476c7c&scoped=true"
import script from "./Addinformation.vue?vue&type=script&lang=js"
export * from "./Addinformation.vue?vue&type=script&lang=js"
import style0 from "./Addinformation.vue?vue&type=style&index=0&id=61476c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61476c7c",
  null
  
)

export default component.exports